var __jsx = React.createElement;
import { observer } from "mobx-react-lite";
import dynamic from "next/dynamic";
import Head from "next/head";
import React, { useEffect } from "react";
import { PageLayout } from "../../util/constants";
import i18next from "i18next";
import { useStore } from "@dp/state";
import { isTrue } from "@dp/common";
var Waitlist = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.JoinWaitlist;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    }
  }
});
var WaitListPage = function WaitListPage(props) {
  var _store$common;
  var store = useStore();
  var brandname = store === null || store === void 0 || (_store$common = store.common) === null || _store$common === void 0 || (_store$common = _store$common.appAttributes) === null || _store$common === void 0 || (_store$common = _store$common.concept) === null || _store$common === void 0 ? void 0 : _store$common.conceptCodeDesc;
  var getDefPageTitle = isTrue(!brandname, "Join The Wait List", "Join The Wait List | ".concat(brandname));
  var pageTitle = i18next.t("text.joinwaitlist.page.title", {
    defaultValue: "".concat(getDefPageTitle),
    interpolation: {
      prefix: "${",
      suffix: "}"
    },
    0: brandname
  });
  var getDefMetaDescription = isTrue(!brandname, "Put your name on online wait list to reserve your place in line before you arrive at the restaurant. Join the wait list here.", "Put your name on ".concat(brandname, "'s online wait list to reserve your place in line before you arrive at the restaurant. Join the wait list here."));
  var metaDescription = i18next.t("text.joinwaitlist.meta.description", {
    defaultValue: getDefMetaDescription,
    interpolation: {
      prefix: "${",
      suffix: "}"
    },
    0: brandname
  });
  useEffect(function () {
    store === null || store === void 0 || store.initComponent("JoinWaitlist").then(function () {
      // NOOP
    });
  }, []);
  return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, pageTitle), __jsx("meta", {
    property: "description",
    content: metaDescription
  })), __jsx(Waitlist, null));
};
WaitListPage.layout = PageLayout.NB_LAYOUT;
WaitListPage.layoutProps = {
  analyticsData: {
    pageName: "wait-list",
    pageType: "wait-list"
  },
  showJoinWaitListHeader: true
};
export default observer(WaitListPage);